import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { FileIcon } from "lucide-react";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";

type NewLabelActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function NewLabelActivity({ activity }: NewLabelActivityProps) {
  const t = useTranslation();

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <FileIcon className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2">
          <ActivityItemHeader
            title={t("returnDetail.newLabel")}
            timestamp={activity.date}
          >
            <span className="font-medium text-xs underline">
              {activity.comment}
            </span>
          </ActivityItemHeader>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
